module.exports = __webpack_public_path__ + "static/media/6.cf1c9f4b.jpg";